import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import CssBaseline from "@mui/material/CssBaseline";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import HomeIcon from "@mui/icons-material/Home";
import PaymentsIcon from "@mui/icons-material/Payments";
import { Route, Routes, useNavigate } from "react-router-dom";
import Home from "./pages/Home";
import Students from "./pages/Students";
import Payments from "./pages/Payments";
import NewStudent from "./pages/NewStudent";
// import HolidayVillageIcon from "@mui/icons-material/HolidayVillage";
import GroupIcon from "@mui/icons-material/Group";
import NewClass from "./pages/NewClass";
import Classes from "./pages/Classes";
import Parents from "./pages/Parents";
import FamilyRestroomIcon from "@mui/icons-material/FamilyRestroom";
import NewParent from "./pages/NewParent";
import NewPayment from "./pages/NewPayment";
import PersonIcon from "@mui/icons-material/Person";
import Cheques from "./pages/Cheques";
import { useState } from "react";
import Admins from "./pages/Admins";
import NewAdmin from "./pages/NewAdmin";
import { queryClient } from ".";
import EditStudent from "./pages/EditStudent";
import {
  AccountCircle,
  Assessment,
  EventNote,
  ExpandLess,
  ExpandMore,
  HolidayVillage,
  MoneyOff,
  Payment,
  School,
} from "@mui/icons-material";
import { Collapse, Menu, MenuItem } from "@mui/material";
import { useMutation } from "react-query";
import axios from "./axios";
import PaymentsReport from "./pages/PaymentsReport";
import ClassReport from "./pages/ClassReport";
import ArrearsReport from "./pages/ArrearsReport";
import Teachers from "./pages/Teachers";
import NewTeacher from "./pages/NewTeacher";
import EditClass from "./pages/EditClass";
import AttendanceReport from "./pages/AttendanceReport";
import AttendanceDashboard from "./pages/AttendanceDashboard";
import MarkAttendance from "./pages/MarkAttendance";
import EditParent from "./pages/EditParent";
const drawerWidth = 240;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

const TeacherApp = () => {
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();

  const logoutMutation = useMutation(() => axios.post("/auth/logout"));

  const handleLogout = async () => {
    await logoutMutation.mutateAsync();
    queryClient.setQueryData("user", null);
  };

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar position="fixed" open={open}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={() => setOpen(true)}
            edge="start"
            sx={{
              marginRight: 5,
              ...(open && { display: "none" }),
            }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1 }}>
            MRI Teacher
          </Typography>
          <div>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={(e) => setAnchorEl(e.currentTarget)}
              color="inherit"
            >
              <AccountCircle />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{ vertical: "top", horizontal: "right" }}
              keepMounted
              transformOrigin={{ vertical: "top", horizontal: "right" }}
              open={Boolean(anchorEl)}
              onClose={() => setAnchorEl(null)}
            >
              <MenuItem onClick={handleLogout}>Logout</MenuItem>
            </Menu>
          </div>
        </Toolbar>
      </AppBar>

      <Drawer variant="permanent" open={open}>
        <DrawerHeader>
          <IconButton onClick={() => setOpen(false)}>
            {theme.direction === "rtl" ? (
              <ChevronRightIcon />
            ) : (
              <ChevronLeftIcon />
            )}
          </IconButton>
        </DrawerHeader>
        <Divider />
        <List>
          <ListItem disablePadding sx={{ display: "block" }}>
            <ListItemButton
              onClick={() => navigate("/attendance")}
              sx={{
                minHeight: 48,
                justifyContent: open ? "initial" : "center",
                px: 2.5,
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: open ? 3 : "auto",
                  justifyContent: "center",
                }}
              >
                <EventNote />
              </ListItemIcon>
              <ListItemText
                primary="Mark Attendance"
                sx={{ opacity: open ? 1 : 0 }}
              />
            </ListItemButton>
          </ListItem>
        </List>
      </Drawer>

      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <DrawerHeader />
        <Routes>
          <Route path="/" element={<AttendanceDashboard />} />
          <Route path="/attendance" element={<AttendanceDashboard />} />
          <Route path="/attendance/:classID" element={<MarkAttendance />} />
        </Routes>
      </Box>
    </Box>
  );
};

const AdminApp = () => {
  const user = queryClient.getQueryData("user");
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const [expandReport, setExpandReport] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();

  // logout user
  const logoutMutation = useMutation(() => axios.post("/auth/logout"));

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    await logoutMutation.mutateAsync();
    queryClient.setQueryData("user", null);
  };

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      {/* Top bar */}
      <AppBar position="fixed" open={open}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={{
              marginRight: 5,
              ...(open && { display: "none" }),
            }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1 }}>
            MRI Admin
          </Typography>
          <div>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleMenu}
              color="inherit"
            >
              <AccountCircle />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
            >
              <MenuItem onClick={handleLogout}>Logout</MenuItem>
            </Menu>
          </div>
        </Toolbar>
      </AppBar>

      {/* Side bar icons */}
      <Drawer variant="permanent" open={open}>
        <DrawerHeader>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === "rtl" ? (
              <ChevronRightIcon />
            ) : (
              <ChevronLeftIcon />
            )}
          </IconButton>
        </DrawerHeader>
        <Divider />
        <List>
          <ListItem disablePadding sx={{ display: "block" }}>
            <ListItemButton
              onClick={() => navigate("/")}
              sx={{
                minHeight: 48,
                justifyContent: open ? "initial" : "center",
                px: 2.5,
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: open ? 3 : "auto",
                  justifyContent: "center",
                }}
              >
                <HomeIcon />
              </ListItemIcon>
              <ListItemText primary={"Home"} sx={{ opacity: open ? 1 : 0 }} />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding sx={{ display: "block" }}>
            <ListItemButton
              onClick={() => navigate("/students")}
              sx={{
                minHeight: 48,
                justifyContent: open ? "initial" : "center",
                px: 2.5,
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: open ? 3 : "auto",
                  justifyContent: "center",
                }}
              >
                <PersonIcon />
              </ListItemIcon>
              <ListItemText
                primary={"Students"}
                sx={{ opacity: open ? 1 : 0 }}
              />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding sx={{ display: "block" }}>
            <ListItemButton
              onClick={() => navigate("/parents")}
              sx={{
                minHeight: 48,
                justifyContent: open ? "initial" : "center",
                px: 2.5,
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: open ? 3 : "auto",
                  justifyContent: "center",
                }}
              >
                <FamilyRestroomIcon />
              </ListItemIcon>
              <ListItemText
                primary={"Parents"}
                sx={{ opacity: open ? 1 : 0 }}
              />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding sx={{ display: "block" }}>
            <ListItemButton
              onClick={() => navigate("/payments")}
              sx={{
                minHeight: 48,
                justifyContent: open ? "initial" : "center",
                px: 2.5,
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: open ? 3 : "auto",
                  justifyContent: "center",
                }}
              >
                <PaymentsIcon />
              </ListItemIcon>
              <ListItemText
                primary={"Payments"}
                sx={{ opacity: open ? 1 : 0 }}
              />
            </ListItemButton>
          </ListItem>

          <ListItem disablePadding sx={{ display: "block" }}>
            <ListItemButton
              onClick={() => navigate("/classes")}
              sx={{
                minHeight: 48,
                justifyContent: open ? "initial" : "center",
                px: 2.5,
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: open ? 3 : "auto",
                  justifyContent: "center",
                }}
              >
                <HolidayVillage />
              </ListItemIcon>
              <ListItemText
                primary={"Classes"}
                sx={{ opacity: open ? 1 : 0 }}
              />
            </ListItemButton>
          </ListItem>

          <ListItemButton onClick={() => setExpandReport(!expandReport)}>
            <ListItemIcon sx={{ pl: 0.5 }}>
              <Assessment />
            </ListItemIcon>
            <ListItemText primary="Reports" />
            {expandReport ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
          <Collapse in={expandReport} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItemButton
                sx={{ pl: open ? 4 : 2.5 }}
                onClick={() => navigate("/reports/payments")}
              >
                <ListItemIcon>
                  <Payment />
                </ListItemIcon>
                <ListItemText primary="Payments Report" />
              </ListItemButton>

              <ListItemButton
                sx={{ pl: open ? 4 : 2.5 }}
                onClick={() => navigate("/reports/class")}
              >
                <ListItemIcon>
                  <HolidayVillage />
                </ListItemIcon>
                <ListItemText primary="Class Report" />
              </ListItemButton>

              <ListItemButton
                sx={{ pl: open ? 4 : 2.5 }}
                onClick={() => navigate("/reports/arrears")}
              >
                <ListItemIcon>
                  <MoneyOff />
                </ListItemIcon>
                <ListItemText primary="Arrears Report" />
              </ListItemButton>

              <ListItemButton
                sx={{ pl: open ? 4 : 2.5 }}
                onClick={() => navigate("/reports/attendance")}
              >
                <ListItemIcon>
                  <EventNote />
                </ListItemIcon>
                <ListItemText primary="Attendance Report" />
              </ListItemButton>
            </List>
          </Collapse>

          {user?.role === "SUPER_ADMIN" && (
            <>
              <ListItem disablePadding sx={{ display: "block" }}>
                <ListItemButton
                  onClick={() => navigate("/teachers")}
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? "initial" : "center",
                    px: 2.5,
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : "auto",
                      justifyContent: "center",
                    }}
                  >
                    <School />
                  </ListItemIcon>
                  <ListItemText
                    primary={"Teachers"}
                    sx={{ opacity: open ? 1 : 0 }}
                  />
                </ListItemButton>
              </ListItem>
              <ListItem disablePadding sx={{ display: "block" }}>
                <ListItemButton
                  onClick={() => navigate("/admins")}
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? "initial" : "center",
                    px: 2.5,
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : "auto",
                      justifyContent: "center",
                    }}
                  >
                    <GroupIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary={"Users"}
                    sx={{ opacity: open ? 1 : 0 }}
                  />
                </ListItemButton>
              </ListItem>
            </>
          )}
        </List>
      </Drawer>

      {/* Side bar content */}
      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <DrawerHeader />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/students" element={<Students />} />
          <Route path="/students/:id" element={<EditStudent />} />
          <Route path="/students/new" element={<NewStudent />} />
          <Route path="/payments" element={<Payments />} />
          <Route path="/payments/new" element={<NewPayment />} />
          <Route path="/classes" element={<Classes />} />
          <Route path="/classes/new" element={<NewClass />} />
          <Route path="/classes/:id" element={<EditClass />} />
           <Route path="/parents" element={<Parents />} />
           <Route path="/parents/new" element={<NewParent />} />
           <Route path="/parents/:id" element={<EditParent />} />
          <Route path="/cheques" element={<Cheques />} />
          <Route path="/reports/payments" element={<PaymentsReport />} />
          <Route path="/reports/class" element={<ClassReport />} />
          <Route path="/reports/arrears" element={<ArrearsReport />} />
          <Route path="/reports/attendance" element={<AttendanceReport />} />
          {user?.role === "SUPER_ADMIN" && (
            <>
              <Route path="/admins" element={<Admins />} />
              <Route path="/admins/new" element={<NewAdmin />} />
              <Route path="/teachers" element={<Teachers />} />
              <Route path="/teachers/new" element={<NewTeacher />} />
            </>
          )}
        </Routes>
      </Box>
    </Box>
  );
};

const AuthenticatedApp = () => {
  const user = queryClient.getQueryData("user");

  if (user?.role === "TEACHER") {
    return <TeacherApp />;
  }

  return <AdminApp />;
};

export default AuthenticatedApp;
